import { render, staticRenderFns } from "./ActiveAlertLongStayListItem.vue?vue&type=template&id=1389a527&scoped=true&lang=pug"
import script from "./ActiveAlertLongStayListItem.vue?vue&type=script&lang=ts"
export * from "./ActiveAlertLongStayListItem.vue?vue&type=script&lang=ts"
import style0 from "./ActiveAlertLongStayListItem.vue?vue&type=style&index=0&id=1389a527&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1389a527",
  null
  
)

export default component.exports